import PokerFaceSpecialOfferPrice from './Button';
import { SpecialOfferProps } from '../types';
import {
    Product,
    ProductsContainer,
    StyledFrame,
    StyledSpecialOffer
} from './style';
import {
    calculateSaleStrokedNumber,
    formattingNumber,
    useCountdown
} from '../../Helper/utils/utils';
import { DefaultSaleBadge } from '../../Badge/Sale/DefaultSaleBadge';
import { EBadgePosition, EBadgeType } from '../../Helper/enums';
import { EBadgeDesignType } from '../../Badge/types';
import { Box } from '@mui/system';
import { generateSalePercentageBasedOnType } from '../../../utils';

function SpecialOffer({
    price,
    buttonColor,
    buttonTextColor,
    borderColor,
    productsList,
    availability,
    endTimeActive,
    backgroundColor,
    backgroundImage,
    selectOffer,
    endTime,
    salePercentage = 0,
    salePercentageDisplayType,
    amountBeforeSale,
    productsQuantityFormat,
    isFree
}: SpecialOfferProps) {
    const countdown = endTimeActive && endTime ? useCountdown(endTime) : '';
    const availabilityText =
        availability?.remaining && availability?.total
            ? `${availability.remaining}/${availability.total}`
            : '';

    return (
        <StyledFrame borderColor={borderColor} onClick={selectOffer}>
            <StyledSpecialOffer backgroundColor={backgroundColor}>
                <div className="frame">
                    {salePercentage > 0 && (
                        <Box className="badge-wrapper">
                            <DefaultSaleBadge
                                salePercentage={salePercentage}
                                position={EBadgePosition.TOP}
                                text={`${generateSalePercentageBasedOnType(
                                    salePercentage,
                                    salePercentageDisplayType
                                )} MORE`}
                                designType={EBadgeDesignType.MIDDLE}
                                type={EBadgeType.SALE}
                                salePercentageDisplayType={
                                    salePercentageDisplayType
                                }
                            />
                        </Box>
                    )}
                    <ProductsContainer
                        backgroundImage={backgroundImage}
                        borderColor={backgroundColor?.colorOne}
                    >
                        {productsList.map((product) => {
                            return (
                                <Product key={product.name} data={product}>
                                    <img
                                        src={product.images.product}
                                        alt="product"
                                    />
                                    <span>{product.quantityDisplay}</span>
                                    {salePercentage > 0 && (
                                        <p className="stroked">
                                            {amountBeforeSale ??
                                                `${formattingNumber(
                                                    calculateSaleStrokedNumber(
                                                        product.quantity,
                                                        salePercentage,
                                                        salePercentageDisplayType
                                                    ),
                                                    productsQuantityFormat
                                                )}`}
                                        </p>
                                    )}
                                </Product>
                            );
                        })}
                    </ProductsContainer>
                    <PokerFaceSpecialOfferPrice
                        price={price}
                        buttonColor={buttonColor}
                        buttonTextColor={buttonTextColor}
                        borderColor={backgroundColor?.colorOne}
                        isFree={isFree}
                    />
                    {countdown && (
                        <span className="availability time">{countdown}</span>
                    )}
                    {availabilityText && (
                        <span className="availability quantity">
                            {availabilityText}
                        </span>
                    )}
                </div>
            </StyledSpecialOffer>
        </StyledFrame>
    );
}

export default SpecialOffer;
